import React, { useRef } from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';

import ListOfLogos from '../basic/ListOfLogos';
import BasicChevron from '../basic/svgs/BasicChevron';

import {
	fixElement,
	unFixElement,
} from '@basic/helper-functions/toggleElementScroll.js';

import theme from '@theme';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const {
	colors,
	breakPoints: { screenQuery },
} = theme;

const Carousel = styled.div``;
const Navigation = styled.div`
	text-align: ${props => (props.left ? `left` : `right`)};
	> * {
		position: relative;
		top: 72%;
	}
	* {
		transition-duration: 0.25s;
	}
	:hover {
		cursor: pointer;
		* {
			transform: scale(1.1);
		}
	}
	-webkit-touch-callout: none; /* iOS Safari */
	-webkit-user-select: none; /* Safari */
	-khtml-user-select: none; /* Konqueror HTML */
	-moz-user-select: none; /* Old versions of Firefox */
	-ms-user-select: none; /* Internet Explorer/Edge */
	user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Opera and Firefox */
`;

const SlickCustomDots = styled.div`
	justify-content: center;

	.testimonial-custom-slider {
		align-self: auto;
		padding: 0 10px;
	}

	.left-arrow {
		transform: rotate(90deg);
		position: relative;
		top: -5px;
	}

	.right-arrow {
		transform: rotate(-90deg);
		position: relative;
		top: -6px;
	}

	li {
		margin: -2px;
	}
`;

export default ({
	dots,
	slides,
	slidesToShow,
	bottomRowLogoLine,
	autoPlay,
	speed,
	navigation = true,
	initialSlide,
	goToSlide,
	fixBody,
	restoreBodyScrollPosition,
	maxImgWidth,
	noTopPadding,
	noBottomPadding,
	...props
}) => {
	const slider = useRef(null);

	const next = () => {
		slider.current?.slickNext();
	};
	const prev = () => {
		slider.current?.slickPrev();
	};

	const sliderSettings = {
		dots: dots,
		swipe: false,
		accessibility: false,
		adaptiveHeight: false,
		speed: speed || 10000,
		slidesToShow: slidesToShow || 1,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1000,
				settings: {
					slidesToShow: slidesToShow - 1 || 1,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
		initialSlide: initialSlide || 0,
		autoplay: autoPlay,
		autoplaySpeed: autoPlay,
		arrows: false,
		appendDots: dots => (
			<SlickCustomDots style={{ display: 'flex', bottom: '-55px' }}>
				<div
					className="testimonial-custom-slider left-arrow"
					onClick={() => prev()}
				>
					<BasicChevron fill={colors.black} />
				</div>
				<ul> {dots} </ul>
				<div
					className="testimonial-custom-slider right-arrow"
					onClick={() => next()}
				>
					<BasicChevron fill={colors.black} />
				</div>
			</SlickCustomDots>
		),
	};

	React.useEffect(() => {
		slider.current?.slickGoTo(goToSlide);
	}, [goToSlide]);

	React.useEffect(() => {
		if (fixBody) {
			const body = document.querySelector('body');
			const scrollPosition = typeof window === 'object' && window.scrollY;
			let timer = setTimeout(() => {
				fixElement(body);
			}, 1000);
			return () => {
				clearTimeout(timer);
				unFixElement(body);
				if (restoreBodyScrollPosition) {
					typeof window === 'object' && window.scrollTo(0, scrollPosition);
				}
			};
		}
	}, [restoreBodyScrollPosition]);

	return (
		<div {...props}>
			<Carousel navigation={navigation}>
				<Slider {...sliderSettings} ref={slider}>
					{slides.map(slide => slide)}
				</Slider>
			</Carousel>
			{bottomRowLogoLine && (
				<ListOfLogos
					noTopPadding={noTopPadding}
					noBottomPadding={noBottomPadding}
					css={{ marginTop: 75 }}
					logos={bottomRowLogoLine}
					maxImgWidth={maxImgWidth}
				/>
			)}
		</div>
	);
};
